import { FundingsTranslation } from 'locales/de/pages/Fundings/fundings';

const en: FundingsTranslation = {
  title: 'Fundinginformation',
  categories: 'Categories',
  columns: {
    title: 'Program',
    description: 'Description',
    requirements: 'Requirements',
    durationAndQuote: 'Duration and Quote',
    process: 'Fundingprocess',
    deadline: 'Deadline',
    focus: 'Main focus',
    contact: 'Contact',
    noDeadline: 'No Deadline'
  },
  create: {
    createModalTitle: 'New Fundinginformation',
    editModalTitle: 'Edit Fundinginformation',
    title: 'Program',
    link: 'Externeral Link',
    description: 'Description',
    requirements: 'Requirements',
    durationAndQuote: 'Duration and Quote',
    process: 'Process',
    deadline: 'Deadline',
    focus: 'Main focus',
    contact: 'Contact',
    category: 'Category',
    steps: { informations: 'Information', preview: 'Preview' },
    warnings: {
      noDeadline:
        'No deadline defined! Without deadline the fundinginformation is visible forever. But it can be activated or deactived manually'
    }
  },
  dialogs: {
    deleteConfirm: {
      title: 'Really delete?',
      message: 'Do you really want to delete this fundinginformation?'
    },
    activate: {
      title: 'Really activate?',
      message: 'The fundinginformation will be visible for everyone'
    },
    deactivate: {
      title: 'Really deactivate?',
      message: 'The fundinginformation will not be visible for anyone except for admins'
    }
  },
  filters: {
    myFundings: 'My Fundings'
  },
  alerts: {
    errorLoading: 'The fundinginformation could not be loaded',
    successfulCreate: 'The fundinginformation has been created',
    successfulUpdate: 'The fundinginformation has been updated',
    successfulDelete: 'The fundinginformation has been deleted',
    successfulActivate: 'The fundinginformation has been activated',
    successfulDeactivate: 'The fundinginformation has been deactivated',
    failedCreate: 'The fundinginformation could not be created',
    failedUpdate: 'The fundinginformation could not be updated',
    failedDelete: 'The fundinginformation could not be deleted',
    failedActivate: 'The fundinginformation could not be activated',
    failedDeactivate: 'The fundinginformation could not be deactivated'
  }
};

export default en;
